let user = document.head.querySelector('meta[name="user"]');
let permisos = document.head.querySelector('meta[name="permisos"]');
let arreglo=[];

function safeJsonParse(value, fallback) {
    try {
        return JSON.parse(value);
    } catch (e) {
        return fallback;
    }
}

module.exports = {
    computed: {
        user(){
            const parsedUser = safeJsonParse(user && user.content ? user.content : '{}', {});

            if (!parsedUser || typeof parsedUser !== 'object') {
                return { sucursal: { categorizaciones: '' } };
            }

            if (!parsedUser.sucursal || typeof parsedUser.sucursal !== 'object') {
                parsedUser.sucursal = { categorizaciones: '' };
            }

            if (parsedUser.sucursal.categorizaciones == null) {
                parsedUser.sucursal.categorizaciones = '';
            }

            return parsedUser;
        },
        permisos(){
            //console.log(permisos.content);
            const parsedPermisos = safeJsonParse(permisos && permisos.content ? permisos.content : '[]', []);
            parsedPermisos.forEach(element => {
                arreglo.push(element.codigo)
            });
            return arreglo;
        }
    },
    methods: {
        hasPermission(permission) {//funciones que se pueden llamar desde cualquier componente de vue
            console.log('funcion hasPermission de prueba ',arreglo);
            return true
        }
    },
    isAuthenticated() {
        return !!(user && user.content);
    },
    guest() {
        return ! this.isAuthenticated;
    },

}